
import { defineComponent, ref } from 'vue';

export default defineComponent({
  setup() {
    const error = ref('');
    const locationId = ref('');

    console.log('window', window.location.href);

    try {
      if (window.self !== window.top) {
        console.log('App is running inside an iframe. That\'s what we want.');
        const urlParams = new URLSearchParams(window.location.search);
        const locationIdValue = urlParams.get('location');
        if (locationIdValue) {
          locationId.value = locationIdValue;
        } else {
          error.value = 'No location ID found in URL. Please verify the custom value has been set in Thrive CRM or contact support.';
        }
      } else {
        console.log('App is not running inside an iframe.');
        error.value = 'The app is not running inside an iframe.';
      }
    } catch (e) {
      console.log('An error occurred while retrieving parent information.', e);
      error.value = 'An error occurred while retrieving parent information. Possibly due to cross-origin restrictions.';
    }

    return {
      locationId,
      error,
    };
  },
});
